<script setup>
import { computed, getCurrentInstance, ref } from "vue"
import Expander from "./../ui/Expander.vue"
import Globe from "@/assets/globe.svg"
import StoreLocaleModal from "@/modules/Modals/StoreLocaleModal"

/// STORE GETTERS
import { useStore } from "../../utils"
const store = useStore()

const isExpanded = ref(false)

const { proxy } = getCurrentInstance()
const modal = proxy.$modal_container

const getRegionOptions = computed(() => {
  return store.getters["locale/GET_REGION_OPTIONS"].map(
    ({ countryCode, name }) => {
      return {
        countryCode,
        name,
        label: countryCode
      }
    }
  )
})

const currentRegion = computed(() => {
  return store.state.locale.localeConfig?.countryCode
})

const changeLocale = countryCode => {
  Bleach.debug.log("changeLocale", countryCode)

  modal
    .launch(StoreLocaleModal, {
      props: {
        targetCountryCode: countryCode,
        context: "user"
      },
      priority: false
    })
    .catch(err => {
      // The store change is rejected in the modal
      console.log("They did not want OK bye", err)
    })
}
</script>

<template>
  <div class="store-control-mobile">
    <div
      class="store-control-mobile__active-section flex--row-start-center text--clr-black"
      @click="
        () => {
          isExpanded = !isExpanded
        }
      "
    >
      <Globe class="store-control-mobile__globe-icon mr-8"></Globe>
      <div class="text-body text--clr-black">
        {{ UI_ELEMENT("nav_menu_store_selector_tite") }}
      </div>
      <div class="text-body text--w-bold text--underline ml-4">
        {{ getRegionOptions.find(r => r.countryCode == currentRegion).name }}
      </div>
    </div>
    <Expander :expanded="isExpanded">
      <div
        class="store-control-mobile__options-list text-body text--w-bold text--clr-black pt-24 pb-12 px-6"
      >
        <div
          class="mb-8"
          :key="region.label"
          v-for="region in getRegionOptions"
          @click="evt => changeLocale(region.countryCode)"
        >
          {{ region.name }}
        </div>
      </div>
    </Expander>
  </div>
</template>

<style lang="scss">
$stroke-width: 1px;

.store-control-mobile {
  &__globe-icon {
    height: 22px;
    stroke: getcolour(bleach_black);

    path,
    circle,
    ellipse {
      stroke: inherit;
      fill: none;
      stroke-width: $stroke-width;
      vector-effect: non-scaling-stroke;
    }

    @include media-breakpoint-up(xl) {
      height: 26px;
    }
  }

  &__options-list {
    column-count: 2;
    column-gap: 12px;
  }
}
</style>
